module.exports = [
  {
    path: '/attendance',
    name: 'attendance',
    query: { page: '排班紀錄' },
    meta: {
      label_en: 'Park Attendance',
      color: '#517FA4',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 1,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '園區員工出勤紀錄',
      image: '/cube/cmcpAttend.png',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/attendance/index.vue')
  },
  {
    path: '/cmcpkpireport',
    name: 'cmcpkpireport',
    meta: {
      label_en: 'Park Sales KPI',
      color: 'var(--color-home-1)',
      icon: 'iconChart',
      icon1: 'chart.svg',
      group: 1,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '園區員工銷售KPI',
      requiresAuth: true,
      manager: ['營運二部'],
      employee: [],
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/cmcpkpi/report.vue')
  },
  {
    path: '/cmcpkpi',
    name: 'cmcpkpi',
    query: { page: '西售-盆栽銷售' },
    meta: {
      label_en: 'Park KPI Setting',
      color: '#517FA4',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 1,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: 'KPI商品指標設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/cmcpkpi/index.vue')
  },
  {
    path: '/SalesRecord',
    name: 'SalesRecord',
    meta: {
      label_en: 'Sales Record',
      color: 'var(--color-home-8)',
      icon: 'iconSale',
      icon1: 'setting.svg',
      group: 1,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: 'ERP銷項紀錄',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/consume/SalesRecord.vue')
  },
  {
    path: '/SalesRecord2',
    name: 'SalesRecord2',
    meta: {
      label_en: 'Sales Charts',
      color: 'var(--color-home-8)',
      icon: 'iconSale',
      icon1: 'chart2.svg',
      group: 1,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: 'ERP銷項圖表',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/consume/SalesRecord2.vue')
  },
  {
    path: '/SalesRecord3',
    name: 'SalesRecord3',
    meta: {
      label_en: 'Daily Summary',
      color: 'var(--color-home-8)',
      icon: 'iconSale',
      icon1: 'chart2.svg',
      group: 1,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '單日報表',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/consume/SalesRecord3.vue')
  },
  {
    path: '/restaurantAttendance',
    name: 'restaurantAttendance',
    query: { store: '松柏軒' },
    meta: {
      label_en: 'Restaurant Attendance',
      color: 'var(--color-rest)',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 2,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '松柏軒員工出勤紀錄',
      image: '/cube/restAttend.png',
      requiresAuth: true,
      manager: null,
      employee: null,
      // note: '更新中...',
      role: ['admin', 'manager', 'employee'],
      disabled: false
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restaurantAttendance2.vue')
  },
  {
    path: '/restaurantWorker',
    name: 'restaurantWorker',
    query: { store: '松柏軒' },
    meta: {
      label_en: 'Restaurant Service KPI',
      color: 'var(--color-rest)',
      icon: 'iconChart',
      icon1: 'chart.svg',
      group: 2,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '松柏軒員工服務KPI',
      requiresAuth: true,
      manager: ['營運一部'],
      employee: [],
      // note: '更新中...',
      role: ['admin', 'manager'],
      disabled: false
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restKPI/restaurantWorker.vue')
  },
  {
    path: '/restaurantSales',
    name: 'restaurantSales',
    query: { store: '松柏軒' },
    meta: {
      label_en: 'Restaurant Sales KPI',
      color: '#BD4B4B',
      icon: 'iconChart',
      icon1: 'chart.svg',
      group: 2,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '松柏軒業務推廣KPI',
      requiresAuth: true,
      manager: ['營運一部'],
      employee: [],
      // note: '更新中...',
      role: ['admin', 'manager'],
      disabled: false
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restKPI/sales.vue')
  },
  {
    path: '/restaurantAttendance_1',
    name: 'restaurantAttendance_1',
    query: { store: '松緣會館' },
    meta: {
      label_en: 'Restaurant Attendance',
      color: 'var(--color-rest)',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 2,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '松緣會館員工出勤紀錄',
      image: '/cube/restAttend.png',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: '更新中...',
      role: ['admin', 'manager', 'employee'],
      disabled: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restaurantAttendance.vue')
  },
  {
    path: '/restaurantWorker_1',
    name: 'restaurantWorker_1',
    query: { store: '松緣會館' },
    meta: {
      label_en: 'Restaurant Service KPI',
      color: 'var(--color-rest)',
      icon: 'iconChart',
      icon1: 'chart.svg',
      group: 2,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '松緣會館員工服務KPI',
      requiresAuth: true,
      manager: ['營運一部'],
      employee: [],
      note: '更新中...',
      role: ['admin', 'manager'],
      disabled: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restKPI/restaurantWorker.vue')
  },
  {
    path: '/restaurantSales_1',
    name: 'restaurantSales_1',
    query: { store: '松緣會館' },
    meta: {
      label_en: 'Restaurant Sales KPI',
      color: '#BD4B4B',
      icon: 'iconChart',
      icon1: 'chart.svg',
      group: 2,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '松緣會館業務推廣KPI',
      requiresAuth: true,
      manager: ['營運一部'],
      employee: [],
      note: '更新中...',
      role: ['admin', 'manager'],
      disabled: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restKPI/sales.vue')
  },
  {
    path: '/GeneralAgencyRecord',
    name: 'GeneralAgencyRecord',
    meta: {
      label_en: 'General Agency Record',
      color: '#49676E',
      icon: 'iconPoint',
      icon1: 'pointA.svg',
      group: 4,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '一般代理商消費紀錄',
      requiresAuth: true,
      manager: null,
      employee: ['業務部', '企劃部'],
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/AgencyRecord/index.vue')
  },
  {
    path: '/SpecialAgencyRecord ',
    name: 'SpecialAgencyRecord',
    meta: {
      label_en: 'Special Agency Record ',
      color: '#49676E',
      icon: 'iconPoint',
      icon1: 'pointA.svg',
      group: 4,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '特約代理商消費紀錄',
      requiresAuth: true,
      manager: null,
      employee: ['業務部', '企劃部'],
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/AgencyRecord/index.vue')
  },
  {
    path: '/recordOnline',
    name: 'recordOnline',
    meta: {
      label_en: 'Online Sales Record',
      color: '#745C8C',
      icon: 'iconRest',
      icon1: 'history.svg',
      group: 5,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: '線上付款明細',
      // image: '/png/auth/bg.jpg',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import('../views/restaurantView/recordOnline.vue')
  },
  {
    path: '/record',
    name: 'record',
    meta: {
      label_en: 'Sales Record',
      color: '#745C8C',
      icon: 'iconRest',
      icon1: 'history.svg',
      group: 5,
      appCube: true,
      category: '出勤/統計',
      production: true,
      title: 'POS銷項明細',
      // image: '/png/auth/bg.jpg',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import('../views/restaurantView/record.vue')
  },
  {
    path: '/charts',
    name: 'charts',
    query: { page: '今日' },
    // component: () => import('../views/restaurant/report/index.vue'),
    component: () => import('../views/charts/index.vue'),
    meta: {
      title: '業績報表',
      label_en: 'Performance Report',
      requiresAuth: true,
      icon1: 'svg/menu/chart.svg',
      icon: 'iconChart',
      size: [40, 40],
      marginTop: 0,
      appCube: true,
      electron: true,
      production: true,
      category: '出勤/統計',
      role: ['admin', 'manager', 'employee'],
      manager: null,
      employee: null,
      color: '#745C8C',
      group: 5,
      nav: false,
      navGroup: '設定'
    }
  // }
  // },
  // {
  //   path: '/PaymentRecord',
  //   name: 'PaymentRecord',
  //   meta: {
  //     label_en: 'Payment Record',
  //     color: 'var(--color-home-3)',
  //     icon: 'iconPoint',
  //     group: 4,
  //     appCube: true,
  //     category: '出勤/統計',
  //     production: true,
  //     title: '代理商領收紀錄',
  //     requiresAuth: true,
  //     manager: null,
  //     employee: ['業務部', '企劃部'],
  //     note: 'COMMING SOON',
  //     role: ['admin', 'manager', 'employee']
  //   },
  //   component: () => import(/* webpackChunkName: "about" */ '../views/PaymentRecord.vue')
  // },
  // {
  //   path: '/PaymentRecord2',
  //   name: 'PaymentRecord2',
  //   meta: {
  //     label_en: 'Payment Record',
  //     color: 'var(--color-home-3)',
  //     icon: 'iconPoint',
  //     group: 4,
  //     appCube: true,
  //     category: '出勤/統計',
  //     production: true,
  //     title: '非代理商領收紀錄',
  //     requiresAuth: true,
  //     manager: null,
  //     employee: ['業務部', '企劃部'],
  //     note: 'COMMING SOON',
  //     role: ['admin', 'manager', 'employee']
  //   },
  //   component: () => import(/* webpackChunkName: "about" */ '../views/PaymentRecord2.vue')
  }
]
